"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const constants_1 = require("@/pages/ApprovedFeedstock/constants");
const StatusIcon = ({ status }) => {
    return (react_1.default.createElement(material_1.Tooltip, { placement: "bottom-start", title: constants_1.LABELS_MAP.get(status) },
        react_1.default.createElement("span", null, constants_1.ICONS_MAP.get(status))));
};
exports.default = StatusIcon;
